export default __webpack_public_path__ + "static/media/Add-Enter-Key.5bf40b3b.png";